import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { WhiteXCloseIcon } from '@ui/icons/src/WhiteXCloseIcon';
import { VisuallyHidden } from '../VisuallyHidden';
import { XButton } from './styles.js';

export const CloseButton = ({
  onClick,
  color = 'border.fur',
  useWhiteX = false,
}) => {
  return (
    <XButton onClick={onClick}>
      {useWhiteX ? (
        <WhiteXCloseIcon alt="" size="40" color={color} />
      ) : (
        <Icon
          iconName="close-circle"
          size="40px"
          color={color}
          alt=""
          id="close_button"
        />
      )}
      <VisuallyHidden>Close Modal</VisuallyHidden>
    </XButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
  useWhiteX: PropTypes.bool,
};
